module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/VGBACCARAT-5c7177ff305d40ca05fab0ce57fa7ff3.png";